var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "filter-bar", class: _vm.$style.filterBar }, [
    _c(
      "div",
      { class: _vm.$style.filters },
      [
        _c("chains-filter", {
          staticClass: "filter",
          class: _vm.$style.filter,
          attrs: { filter: _vm.filters.chains, chains: _vm.chains },
          on: { filtersChanged: _vm.chainFiltersChanged },
        }),
        _c("distance-filter", {
          staticClass: "filter",
          class: _vm.$style.filter,
          attrs: { distance: _vm.filters.maxDistance },
          on: { distanceChanged: _vm.distanceFilterChanged },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }